import { render, staticRenderFns } from "./sliding-sheet.vue?vue&type=template&id=457ee21a&scoped=true"
import script from "./sliding-sheet.vue?vue&type=script&lang=js"
export * from "./sliding-sheet.vue?vue&type=script&lang=js"
import style0 from "./sliding-sheet.vue?vue&type=style&index=0&id=457ee21a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457ee21a",
  null
  
)

export default component.exports